

















































































































import BaseComponent from '@/components/base-component.vue';
import InstitutionEvolutionCharts from '@/components/crm/institution-evolution/institution-evol-chart.vue';
import CrmInstitutionEvolutionFilters from '@/components/crm/institution-evolution/institution-evol-filters.vue';
import InstitutionEvolutionTable from '@/components/crm/institution-evolution/institution-evol-table.vue';
import InstitutionTop10Chart from '@/components/crm/institution-evolution/institution-top10-chart.vue';
import InstitutionTop10GrowthChart from '@/components/crm/institution-evolution/institution-top10-growth-chart.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import { InstitEvolucaoFiltrosDTO } from '@/interfaces/crm-institution-evolution';
import { listCrmInstitutionEvolutionChartsData } from '@/services/crm-institution-evolution';
import { BehaviorSubject } from 'rxjs';
import Component from 'vue-class-component';

@Component({
  components: {
    UiFilterContainer,
    CrmInstitutionEvolutionFilters,
    InstitutionTop10Chart,
    InstitutionEvolutionTable,
    InstitutionEvolutionCharts,
    InstitutionTop10GrowthChart
  }
})
export default class InstitutionEvolution extends BaseComponent {
  kpis = null;
  loadingKpis = false;

  filters = null;
  keyValue = 0;

  beforeMount() {
    this.buildBs();
  }

  mounted() {}

  bs$: BehaviorSubject<any> = new BehaviorSubject(null);

  buildBs() {
    this.bs$ = this.buildBehaviorSubject(
      (f) => {
        return listCrmInstitutionEvolutionChartsData(f);
      },
      () => {
        this.loadingKpis = true;
        this.kpis = null;
      },
      300,
      (res) => {
        this.kpis = res;
        this.loadingKpis = false;
        setTimeout(() => {
          this.keyValue++;
        }, 300);
      },
      (error) => {
        this.loadingKpis = false;
        this.showToastApiError(error);
        this.buildBs();
      }
    );
  }

  onFilter(f) {
    this.filters = f;
    this.loadAll();
  }

  loadAll() {
    this.loadChartsData();
  }

  loadChartsData() {
    this.bs$.next(this.buildParms());
  }

  buildParms() {
    let parm = new InstitEvolucaoFiltrosDTO();
    parm.mes = this.filters.month;
    parm.tipoPaciente = this.filters.patientType;
    parm.cdsAreasGeo = this.filters.cdsGeoAreas;
    return parm;
  }

  getTop1GrowthName() {
    if (!this.kpis || !this.kpis.top10Crescimento || !this.kpis.top10Crescimento.length) {
      return null;
    }
    let item = this.kpis.top10Crescimento[0];
    return `${item.nomeInstituicao.substring(0, item.nomeInstituicao.indexOf('-'))}`;
  }

  getTop1GrowthValue() {
    if (!this.kpis || !this.kpis.top10Crescimento || !this.kpis.top10Crescimento.length) {
      return null;
    }
    let item = this.kpis.top10Crescimento[0];
    return `▲${Math.abs(item.crescimentoAbs)} (+${this.decimalFormatHelper(item.crescimentoPerc, 0)}%)`;
  }

  getTop1DecreaseName() {
    if (!this.kpis || !this.kpis.top10Reducao || !this.kpis.top10Reducao.length) {
      return null;
    }
    let item = this.kpis.top10Reducao[0];
    return `${item.nomeInstituicao.substring(0, item.nomeInstituicao.indexOf('-'))}`;
  }

  getTop1DecreaseValue() {
    if (!this.kpis || !this.kpis.top10Reducao || !this.kpis.top10Reducao.length) {
      return null;
    }
    let item = this.kpis.top10Reducao[0];
    return `▼${Math.abs(item.crescimentoAbs)} (${this.decimalFormatHelper(item.crescimentoPerc, 0)}%)`;
  }

  getTop10DetailsTitle() {
    if (!this.kpis || !this.kpis.top10Volume || !this.kpis.top10Volume.length) {
      return '';
    }
    let title = ' - ';
    let qtde = this.kpis.top10Volume.reduce((acc, cur) => acc + cur.valor, 0);
    title += qtde + ' prescrições';
    title += ' (' + this.decimalFormatHelper((qtde / this.kpis.totalPrescricoes) * 100, 1) + '% da carteira)';
    return title;
  }

  getDsProjection() {
    return this.kpis && this.kpis.projecao ? ' *' : '';
  }
}
